import React from 'react';
import PropTypes from 'prop-types';
import { capitalize, map } from 'lodash';
import { Button, Dropdown, DropdownButton } from 'react-bootstrap';

import LinkContainer from '../../containers/LinkContainer';
import ButtonUpgrade from '../ButtonUpgrade';

const NewSingleItem = ({
  isPremium,
  isFreeUserAtLimit,
  newItemRoute,
  itemName,
  openInNewTab,
  createdNewItem
}) => {
  if (!isPremium && isFreeUserAtLimit) {
    return <ButtonUpgrade />;
  }

  if (openInNewTab) {
    return (
      <Button target="_blank" href={`${itemName}/new`} variant="outline-success">{`Add ${capitalize(
        itemName
      )}`}</Button>
    );
  }
  return (
    <LinkContainer to={newItemRoute}>
      <Button disabled={!createdNewItem} variant="outline-success">{`Add ${capitalize(
        itemName
      )}`}</Button>
    </LinkContainer>
  );
};
NewSingleItem.defaultProps = {
  createdNewItem: true,
  openInNewTab: false
};

NewSingleItem.propTypes = {
  createdNewItem: PropTypes.bool,
  isFreeUserAtLimit: PropTypes.bool.isRequired,
  openInNewTab: PropTypes.bool,
  newItemRoute: PropTypes.string.isRequired,
  itemName: PropTypes.string.isRequired,
  isPremium: PropTypes.bool.isRequired
};

const NewMultipleItem = ({ newItemRoute, eventKey, isFreeUserAtLimit, isPremium, itemName }) => {
  if (!isPremium && isFreeUserAtLimit) {
    return <ButtonUpgrade isMenuItem eventKey={eventKey} />;
  }
  return (
    <LinkContainer to={newItemRoute}>
      <Dropdown.Item eventKey={eventKey}>{`Add ${capitalize(itemName)}`}</Dropdown.Item>
    </LinkContainer>
  );
};
NewMultipleItem.propTypes = {
  eventKey: PropTypes.number.isRequired,
  newItemRoute: PropTypes.string.isRequired,
  isFreeUserAtLimit: PropTypes.bool.isRequired,
  itemName: PropTypes.string.isRequired,
  isPremium: PropTypes.bool.isRequired
};

const ButtonNewItem = ({ createdNewItem, isPremium, newItems }) => {
  if (newItems.length === 1) {
    const [item] = newItems;
    return <NewSingleItem isPremium={isPremium} createdNewItem={createdNewItem} {...item} />;
  }
  return (
    <DropdownButton id="NewItemButton" variant="success" title="New ..." alignRight>
      {map(newItems, item => (
        <NewMultipleItem key={item.newItemRoute} isPremium={isPremium} {...item} />
      ))}
    </DropdownButton>
  );
};
ButtonNewItem.defaultProps = {
  createdNewItem: true
};
ButtonNewItem.propTypes = {
  isPremium: PropTypes.bool.isRequired,
  createdNewItem: PropTypes.bool,
  newItems: PropTypes.arrayOf(
    PropTypes.shape({
      eventKey: PropTypes.number,
      isFreeUserAtLimit: PropTypes.bool.isRequired,
      newItemRoute: PropTypes.string.isRequired,
      itemName: PropTypes.string.isRequired
    })
  ).isRequired
};
export default ButtonNewItem;
